export { PageHeadingV3 } from './PageHeadingV3';
